import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { formatNumber } from 'shared/web3';

import EmptyBox from 'assets/png/boxes/empty-box.png?format=webp;avif&as=picture';
import FullBox from 'assets/png/boxes/full-box.png?format=webp;avif&as=picture';
import MiddleBox from 'assets/png/boxes/middle-box.png?format=webp;avif&as=picture';
import SmallBox from 'assets/png/boxes/small-box.png?format=webp;avif&as=picture';

/**
 * Formats a token balance for display.
 * @param amount The token balance to format.
 * @returns The formatted token balance.
 */
export const formatTokenBalance = (amount?: number) => {
  const n = Number.isFinite(amount as number) ? (amount as number) : 0;
  if (n === 0) return '0';
  if (n >= 1) return formatNumber(n);
  return n.toLocaleString(undefined, { maximumFractionDigits: 6 });
};

export interface IOption {
  value: string;
  label: string;
  address: string;
}

interface IGetBoxProps {
  balance: number;
  bet: number | string;
  betThresholds?: (number | string)[];
}

export function getOptionsWithBalances(
  options: IOption[] = [],
  chainBalances: Record<string, number> = {},
) {
  return options.map((option) => {
    const key = option.address.toLowerCase();
    const bal = chainBalances?.[key] ?? 0;
    const formattedLabel = bal > 0 ? `${option.value} (${formatTokenBalance(bal)})` : option.value;

    return {
      ...option,
      label: formattedLabel,
    };
  });
}

export function getSelectedOptionWithBalance(selectedCurrency: { value: string; symbol: string }) {
  return {
    value: selectedCurrency.value,
    label: selectedCurrency.symbol,
  };
}

export function getBox({ balance, bet, betThresholds = [] }: IGetBoxProps) {
  const numericBet = +bet;

  if (balance <= 0) {
    return (
      <OptimizedImage imageData={EmptyBox} alt="empty-box" className="z-10 mx-auto max-w-[14rem]" />
    );
  }

  if (betThresholds.length >= 3 && numericBet >= Number(betThresholds[2])) {
    return (
      <OptimizedImage imageData={FullBox} alt="full-box" className="z-10 mx-auto max-w-[16rem]" />
    );
  } else if (betThresholds.length >= 2 && numericBet >= Number(betThresholds[1])) {
    return (
      <OptimizedImage
        imageData={MiddleBox}
        alt="middle-box"
        className="z-10 mx-auto max-w-[16rem]"
      />
    );
  } else {
    return (
      <OptimizedImage imageData={SmallBox} alt="small-box" className="z-10 mx-auto max-w-[16rem]" />
    );
  }
}
